"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export default function WhatsAppWidget() {
  const phoneNumber = "+393384682171";
  const message = encodeURIComponent("Ciao, vorrei informazioni!");
  const url = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-50"
      aria-label="Contattaci su WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} size="xl" />
    </a>
  );
}
